import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import classNames from 'classnames';
import { ProgressBar } from '../../components';
import { SlidingDirections } from '../../enums';
import styles from './ScrollSlider.module.scss';
const ScrollSlider = ({ children, className, containerClassname, onSlide, shouldShowProgressBar = true, }) => {
    const scrollElement = useRef(null);
    const [currentPercent, setCurrentPercent] = useState(0);
    const scrollingTimeout = useRef(null);
    const scrollStartX = useRef(null);
    const scrollEndX = useRef(null);
    const timeout = 66;
    const handleScroll = (event) => {
        if (!scrollElement.current) {
            return;
        }
        const element = event.target;
        if (scrollingTimeout.current) {
            clearTimeout(scrollingTimeout.current);
        }
        else {
            scrollStartX.current = element.scrollLeft;
        }
        scrollingTimeout.current = setTimeout(() => {
            if (onSlide) {
                const direction = scrollStartX.current !== null &&
                    scrollEndX.current !== null &&
                    scrollStartX.current - scrollEndX.current < 0
                    ? SlidingDirections.Next
                    : SlidingDirections.Previous;
                onSlide(direction);
            }
            scrollStartX.current = null;
            scrollingTimeout.current = null;
        }, timeout);
        const { offsetWidth, scrollLeft } = element;
        scrollEndX.current = scrollLeft;
        if (scrollElement.current) {
            setCurrentPercent((100 * scrollLeft) / (scrollElement.current.scrollWidth - offsetWidth));
        }
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: classNames(styles.scrollSlider, className), "data-testid": "scroll-slider", children: _jsx("div", { className: styles.scrollSliderViewContainer, children: _jsx("div", { className: classNames(styles.scrollSliderContainer, containerClassname), onScroll: handleScroll, "data-testid": "scroll-slider-container", children: _jsx("div", { className: styles.scrollSliderContent, ref: scrollElement, children: children }) }) }) }), shouldShowProgressBar && _jsx(ProgressBar, { currentPercent: currentPercent })] }));
};
export { ScrollSlider };
